// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

Vue.config.productionTip = false


import '../static/public.css'
import '../static/iconfont/iconfont.css'


import microApp from '@micro-zoe/micro-app'
microApp.start({
  iframe: true, // 全局开启iframe沙箱，默认为false
  inline: true, // 全局开启内联script模式运行js，默认为false
  destroy: true, // 全局开启destroy模式，卸载时强制删除缓存资源，默认为false
  ssr: true, // 全局开启ssr模式，默认为false
  'disable-scopecss': true, // 全局禁用样式隔离，默认为false
  'disable-sandbox': true, // 全局禁用沙箱，默认为false
  'keep-alive': true, // 全局开启保活模式，默认为false
  'disable-memory-router': true, // 全局关闭虚拟路由系统，默认值false
  'keep-router-state': true, // 子应用在卸载时保留路由状态，默认值false
  'disable-patch-request': true, // 关闭子应用请求的自动补全功能，默认值false
  iframeSrc: location.origin, // 设置iframe沙箱中iframe的src地址，默认为子应用所在页面地址
  inheritBaseBody: true, // true: 采用基座标签 作为子应用的标签， false: 不采用
  //aHrefResolver: (hrefValue: string, appName: string, appUrl: string) => string, // 自定义处理所有子应用 a 标签的 href 拼接方式
})
/*

import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'

// Install BootstrapVue
Vue.use(BootstrapVue)
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin)
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

import 'bootstrap/dist/js/bootstrap.js'
import 'bootstrap/dist/js/bootstrap.bundle';
*/


import VueAwesomeSwiper from 'vue-awesome-swiper';
import 'swiper/dist/css/swiper.css';
Vue.use(VueAwesomeSwiper);



import Cookies from "js-cookie"
Vue.prototype.$cookie = Cookies;

var luanshu=Math.random();




Vue.prototype.$api_url = '/api';//shengchan
import axios from 'axios';
Vue.prototype.axios = axios.create({
  withCredentials: true,
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8',
    'Sys-Name':'ykhome',
    'Sys-version':'2026006.01',
  },
  transformRequest: [function (data) {
    let newData = '';
    for (let k in data) {
      if (data.hasOwnProperty(k) === true) {
        newData += encodeURIComponent(k) + '=' + encodeURIComponent(data[k]) + '&';
      }
    }
    return newData;
  }]
})
Vue.prototype.reWriteurl = function(url){
  let _url = ''
  if (process.env.NODE_ENV === 'development') {//这个是开发环境下
    _url = url;
  } else if (process.env.NODE_ENV === 'production') {//这个是生产环境下
    _url = url

    url = url.replace("/api", ""); //如果uri不一样就替换成一样的
    _url = process.env.APP_BASE_APP_API + url;

  }
  return _url;
}
Vue.prototype.pbfasong = function (url, data = {},succfun,errfun) {
  let _url = ''
  if (process.env.NODE_ENV === 'development') {//这个是开发环境下
    _url = url;
  } else if (process.env.NODE_ENV === 'production') {//这个是生产环境下
    _url = url

    url = url.replace("/api", ""); //如果uri不一样就替换成一样的
    _url = process.env.APP_BASE_APP_API + url;

  }
  new Promise((resolve, reject) => {
    this.axios.post(_url, data).then(res => {
      succfun(res.data);
    }).catch(function(error) {
      errfun(error)
    })
  })
}



Vue.prototype.check_havecookie=function(){
  var puid = Vue.prototype.$cookie.get('puid');

  if (process.env.NODE_ENV === 'development') {
    //这个是开发环境下
    puid = 'ExxqjFX71779931583';
  } else if (process.env.NODE_ENV === 'production'){}

  if(!puid){
    puid='';
  }
  return puid;
}

Vue.prototype.setCookie=function (val, name,outtime) {
  Vue.prototype.$cookie.set(name,val,{expires:outtime});
}
Vue.prototype.getCookie=function (name) {
  var val = Vue.prototype.$cookie.get(name);

  if(!val){return '';}
  return val;

}
Vue.prototype.delCookie= function (name) {
  Vue.prototype.$cookie.remove(name);
}


var url = Vue.prototype.$api_url+"token/gettoken";

var benditokenval =Vue.prototype.getCookie('yktoken');

//获取token
if(benditokenval===''){

  run_get_token((res)=>{
    run_jiazai(res.token)
  },(res,msg='')=>{
    alert('当前页面token获取失败,请刷新页面');
  });

}else{

  run_check_token((res)=>{
    console.log(res);
    run_jiazai(res.token);
  },(res,msg='')=>{
    alert();
  });

}


function run_check_token(succ,err) {
  var nowtoken = Vue.prototype.getCookie('yktoken');
  var url = Vue.prototype.$api_url+"token/checktoken";
  var senddata = {
    'token':nowtoken,
  }
  Vue.prototype.pbfasong(url,senddata,function (res) {
    //console.log(res);
    if(res===true){
      succ(res);
      return false;
    }
    err(res,'页面已过期');
  },function (eres) {
    err(err,'接口报错');
  });
}

function run_get_token(succ,err){
  Vue.prototype.pbfasong(url,{},function (res) {

    if(res===-1){
      err(res,'后端报错');
      return false;
    }
    if(res===-2){
      err(res,'接口判定无权限');
      return false;
    }
    if(res.code===true){
      Vue.prototype.setCookie(res.token,'yktoken',res.endday);
      succ(res);
      return false;
    }
    err(res,'未知错误');

  },function (eres) {
    err(res,'传出报错');
  })
}


router.beforeEach((to,from,next)=>{

  if(to.matched.some(record=>record.meta.requireAuth)){
    next();
  }else{
    next();
  }

});


function run_jiazai(tokenKey){
  var jsurl ='';
  if (process.env.NODE_ENV === 'development') {//这个是开发环境下
    jsurl =  'http://localhost:3001/ykinit?tm='+luanshu;
  } else if (process.env.NODE_ENV === 'production') {
    jsurl  =  'https://www.goyoku.com/ykinit?tm='+luanshu;
  }
  window.loadScript(jsurl,()=>{
    new Vue({
      el: '#app',
      router,
      components: { App },
      template: '<App/>'
    })
  })
}


/* eslint-disable no-new */
/*
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})

 */



// WEBPACK FOOTER //
// ./src/main.js